import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';

export interface IUpdateViewerControlledThemeParams {
    viewerControlledTheme: number;
}

export class UpdateViewerControlledThemeRequest extends Request<IUpdateViewerControlledThemeParams, IResult> {
    constructor(params: IUpdateViewerControlledThemeParams) {
        super('updateViewerControlledTheme', params);
    }
}
